import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { WebServiceService } from '../../shared/services/web-service.service';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector: 'app-dynamic-chart',
  templateUrl: './dynamic-chart.component.html',
  styleUrls: ['./dynamic-chart.component.scss']
})
export class DynamicChartComponent implements OnInit {
  // @Input() dataTosend: any;
  // Pie
  @Input() labels: string[];
  @Input() data: number[];
  @Input() pieChartType?: string = 'pie';
  @Input() colors?: any = ['#5fb2c6', '#53a759', '#e88b44', '#e23f3d']
  @Input() lineChartLegend?:boolean=true;
  @Input() title:any;
  pieChartColors: any;
  public pieChartPlugins = [pluginDataLabels];


  public options: any = {
    legend: {
      display: true,
      position: 'right',
      labels: {
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;
          return datasets[0].data.map((data, i) => ({
            text: chart.data.labels[i].length > 30 ? chart.data.labels[i].substring(0, 30) + '...' : chart.data.labels[i],
            fillStyle: datasets[0].backgroundColor[i],
            index: i,
            oldText: chart.data.labels[i]
          }));
        },
        
      },
      onHover: function (event, legendItem) {
        let tooltip = document.getElementById("tooltip");
        if (tooltip) {
          tooltip.innerHTML = legendItem.oldText;
          tooltip.style.left = `${event.clientX + 10}px`; // Tooltip on hover near the cursor
          tooltip.style.top = `${event.clientY + 10}px`;
          tooltip.style.position = "absolute";
          tooltip.style.display = 'block'; // Show tooltip
        }
      },
      onLeave: function () {
        let tooltip = document.getElementById("tooltip");
        if (tooltip) {
          tooltip.innerHTML = "";
          tooltip.style.display = 'none'; // Hide tooltip when leaving
        }
      }
    },
    plugins: {
      datalabels: {
        display: false // Hiding the data labels, you can turn it on if needed
      }
    }
  };
  
  constructor(private router: Router,public webService: WebServiceService,) { }

  ngOnInit() {
    this.pieChartColors = [{ backgroundColor: this.colors }];
  }

  public chartClicked(e: any): void {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        const label = chart.data.labels[clickedElementIndex];
        // get value by index
        const value = chart.data.datasets[0].data[clickedElementIndex];
        this.navigateUrl(label,value);
        this.navigatesUrl(label,value);
      }
    }
  }

  chartHovered(e: any): void {
  }


  public navigatesUrl(label: string, value: any): void {
    let url = "";
    let project = '';
    let dashboardAction = "";
    
    // Extract the part before the first '(' to handle cases like "Approved PR (1222 (69,91,46,129.25 INR))"
    const labelText = label.split('(')[0].trim(); // This will extract "Approved PR"
    
    switch (labelText) {
      case "Approved PR":
        // Custom logic for when "Approved PR" is clicked
        window.location.href = window.location.origin + '/report/#/pr-wise-report';
        project = 'reports';
        dashboardAction = "approved_pr";
        break;
      
      case "Withdrawn PR":
        window.location.href = window.location.origin + '/report/#/pr-wise-report';
        project = 'reports';
        dashboardAction = "pr_withdrawn";
        break;
      
      case "Pending for Approval":
        window.location.href = window.location.origin + '/report/#/pr-wise-report';
        project = 'reports';
        dashboardAction = "pending_pr";
        break;
      
      case "Rejected PR":
        window.location.href = window.location.origin + '/report/#/pr-wise-report';
        project = 'reports';
        dashboardAction = "rejected_pr";
        break;
      
      case "Total PR":
        window.location.href = window.location.origin + '/report/#/pr-wise-report';
        project = 'reports';
        dashboardAction = "raised_pr";
        break;
      
      case "Hold PR":
        window.location.href = window.location.origin + '/report/#/pr-wise-report';
        project = 'reports';
        dashboardAction = "pr_hold";
        break;
  
      case "Closed PO":
        window.location.href = window.location.origin + '/report/#/po-report';
        project = 'reports';
        dashboardAction = "po_closed";
        break;
  
      case "Approved PO":
        window.location.href = window.location.origin + '/report/#/po-report';
        project = 'reports';
        dashboardAction = "approved_po";
        break;
  
      case "Pending for Approval PO":
        window.location.href = window.location.origin + '/report/#/po-report';
        project = 'reports';
        dashboardAction = "pending_po";
        break;
  
      case "Rejected PO":
        window.location.href = window.location.origin + '/report/#/po-report';
        project = 'reports';
        dashboardAction = "rejected_po";
        break;
  
      case "Total PO":
        window.location.href = window.location.origin + '/report/#/po-report';
        project = 'reports';
        dashboardAction = "raised_po";
        break;
  
      case "Hold PO":
        window.location.href = window.location.origin + '/report/#/po-report';

        project = 'reports';
        dashboardAction = "po_hold";
        break;
  
      case "Cancelled PO":
        window.location.href = window.location.origin + '/report/#/po-report';
        project = 'reports';
        dashboardAction = "po_cancelled";
        break;
  
      default:
        console.log("No matching case for label: " + labelText);
        return;
    }
  
    // Check if we have a URL to redirect
    if (url) {
      window.location.href = window.location.origin + '/#' + url;
    }
    // Store dashboardAction and project in localStorage if needed
    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction, 'dashboardAction'));
  }
  
  navigateUrl(key, value) {
    // if (count <= 0) {
    //   this.toasterService.pop("info", "Info", title + " = " + count);
    //   return false;
    // }
    let url = "";
    let project = '';
  
    let dashboardAction = ""
    switch (key) {
      case "All Raised PR" + " (" + value + ")":
        url = "/my-purchases-pr";
        project = 'operation'
  
        dashboardAction = ""
        break;
  
      case "All Pending PR" + " (" + value + ")":
        url = "/my-purchases-pr";
        project = 'operation'
        dashboardAction = "pending_pr"
        break;
  
      case "All Rejected PR" + " (" + value + ")":
        url = "/my-purchases-pr";
        project = 'operation'
        dashboardAction = "rejected_pr"
        break;
      case "All Approved PR" + " (" + value + ")":
        url = "/my-purchases-pr";
        project = 'operation'
        dashboardAction = "approved_pr"
        break;

      case "approved_pr" + " (" + value + ")":
        url = "/my-orders";
        project = 'operation'
        dashboardAction = ""
        break;
      case "All Pending PO" + " (" + value + ")":
        url = "/my-orders";
        project = 'operation'
        dashboardAction = "pending_po"
        break;
      case "All Approved PO" + " (" + value + ")":
        url = "/my-orders";
        project = 'operation'
        dashboardAction = "approved_po"
        break;
      case "All Rejected PO" + " (" + value + ")":
        url = "/my-orders";
        project = 'operation'
        dashboardAction = "rejected_po"
        break;
      case "Total Received Items" + " (" + value + ")":
        url = "";
        project = 'operation'
        dashboardAction = "received_items"
        break;
      case "Total Items" + " (" + value + ")":
        url = "";
        project = 'operation'
        dashboardAction = ""
        break;
      case "Total Accepted Items" + " (" + value + ")":
        url = "";
        project = 'operation'
        dashboardAction = "accepted_items"
        break;
      case "Total Rejected Items" + " (" + value + ")":
        url = "";
        project = 'operation'
        dashboardAction = "rejected_items"
        break;
      case "Total Damaged Items" + " (" + value + ")":
        url = "";
        project = 'operation'
        dashboardAction = "damaged_items"
        break;
      case "Total Damaged Items" + " (" + value + ")":
        url = "";
        project = 'operation'
        dashboardAction = "damaged_items"
        break;
      case "All Invoice" + " (" + value + ")":
        url = "/all-invoices";
        project = 'operation'
        dashboardAction = ""
        break;
      case "All Pending Invoice" + " (" + value + ")":
        url = "/all-invoices";
        project = 'operation'
        dashboardAction = "pending_iv"
        break;
      case "All Approved Invoice" + " (" + value + ")":
        url = "/all-invoices";
        project = 'operation'
        dashboardAction = "approved_iv"
        break;
      case "All Rejected Invoice" + " (" + value + ")":
        url = "/all-invoices";
        project = 'operation'
        dashboardAction = "rejected_iv"
        break;
      case "all_invoice_payment" + " (" + value + ")":
        url = "/my-invoices";
        project = 'operation'
        dashboardAction = ""
        break;
      case "All Pending Invoice Payment" + " (" + value + ")":
        url = "/my-invoices";
        project = 'operation'
        dashboardAction = "pending_ip"
        break;
      case "All Approved Invoice Payment" + " (" + value + ")":
        url = "/my-invoices";
        project = 'operation'
        dashboardAction = "approved_ip"
        break;
      case "All Rejected Invoice Payment" + " (" + value + ")":
        url = "/my-invoices";
        project = 'operation'
        dashboardAction = "rejected_ip"
        break;
      default:
        url = "";
    }
    localStorage.setItem("dashboardAction", this.webService.set(dashboardAction, 'dashboardAction'));
    if (url != '' && url != undefined) {
      let redirectUrl = '/#';
      let origin = window.location.origin;
      if (project == 'master') {
        redirectUrl = origin + '/master' + redirectUrl + url;
      } else if (project == 'reports') {
        redirectUrl = origin + '/report' + redirectUrl + url;
      } else if (project == 'mapping') {
        redirectUrl = origin + '/mapping' + redirectUrl + url;
      } else if (project == 'finance') {
        redirectUrl = origin + '/finance' + redirectUrl + url;
      }
      else if (project == 'project_management') {
        redirectUrl = origin + '/project_management/' + redirectUrl + url;
      }
  
      else {
        if (url == '#' || !url) return;
        this.webService.redirectURL(url);
        return;
      }
      window.location.href = redirectUrl;
    }
  }
  downloadCanvas(event,name) {
    let anchor = event.target;
    // get the canvas
    anchor.href = document.getElementsByTagName('canvas')[0].toDataURL();
    name=name?name:'report';
    anchor.download = name+".png";
  }


}



// WEBPACK FOOTER //
// /codebuild/output/src1465393655/src/src/app/common/dynamic-chart/dynamic-chart.component.ts